// TODO myOrderHistory 로 변경; src/v2-store/legacy/myOrderHistory.js 삭제시점에

import API, { initApiUrl } from '@/store/api'

import { ofOrder } from '@/models/MyOrder/Order'
import { ofPage } from '@/models/MyOrder/Page'
import ResultSet from '@/models/Common/ResultSet'
import { ofChatbot } from '@/models/Chatbot'

initApiUrl('')

const myOrderHistoryV2 = {
  namespaced: true,
  state: {
    inProgressOrders: [],
    notInProgressOrderPage: ofPage(),

    isUpdate: true,
    appVersion: '',
    chatbot: ofChatbot()
  },
  mutations: {
    setInProgressOrders: (state, payload) => {
      state.inProgressOrders = payload
    },
    setNotInProgressOrderPage: (state, { page, reset = false }) => {
      state.notInProgressOrderPage = {
        ...state.notInProgressOrderPage,
        ...page,
        content: reset ? [ ...page.content ] : [ ...state.notInProgressOrderPage.content, ...page.content ]
      }
    },
    setIsUpdate: (state, payload) => {
      state.isUpdate = payload
    },
    setAppVersion: (state, payload) => {
      state.appVersion = payload
    },
    setChatbotStatus: (state, payload) => {
      state.chatbot = ofChatbot(payload)
    }
  },
  getters: {
    inProgressOrders: (state) => state.inProgressOrders,
    notInProgressOrderPage: (state) => state.notInProgressOrderPage,
    isUpdate: (state) => state.isUpdate,
    appVersion: (state) => state.appVersion,
    isEmptyOrders: (state) => state.inProgressOrders.length === 0 && state.notInProgressOrderPage.content.length === 0,
    chatbotStatus: (state) => state.chatbot
  },
  actions: {
    loadInProgressOrders: async ({ commit, rootState }, reset = false) => {
      try {
        if (reset) commit('setInProgressOrders', [])

        const option = {
          headers: {
            'user-baedal': rootState.user.authorization.key,
            'SESSION-ID': rootState.user.authorization.sessionId,
            Authorization: `Bearer ${rootState.user.authorization.accessToken}`
          }
        }
        // TODO check src/components/my/order/Delivering.vue:68
        const result = await API.get('/v1/orders/delivering', option)
        // if (result.code === '401') return result
        if (result.code !== '200') return result

        commit('setInProgressOrders', result.result.map((e) => ofOrder(e)))

        return result.result
      } catch (error) {
        return error.response.data.result
      }
    },
    loadNotInProgressOrderPage: async ({ commit, rootState }, reset = false) => {
      try {
        if (reset) commit('setNotInProgressOrderPage', { page: ofPage(), reset: true })

        const option = {
          headers: {
            'user-baedal': rootState.user.authorization.key,
            'SESSION-ID': rootState.user.authorization.sessionId
          }
        }
        // TODO check src/components/my/order/Delivered.vue:66
        const { pageNumber } = rootState.myOrderHistoryV2.notInProgressOrderPage.pageable
        const { code, result } = await API.get(`/v1/orders/delivered?page=${pageNumber + 1}`, option)
        if (code !== '200') return result

        commit('setNotInProgressOrderPage', { page: ofPage(result, { contentFactory: ofOrder }) })

        return result
      } catch (error) {
        return error.response.data.result
      }
    },
    checkServiceArea: async ({ rootState }) => {
      const option = {
        headers: {
          'user-baedal': rootState.user.authorization.key
        }
      }

      const result = await API.get('/v1/main/shop', option)

      if (result.code !== '200') return ResultSet.fail(result)
      if (result.failed) return ResultSet.fail(result)

      return ResultSet.ok({ result: result.result, message: result.message })
    },

    loadChatbot: async ({ commit, rootState }) => {
      try {
        const option = {
          headers: {
            'user-baedal': rootState.user.authorization.key
          }
        }

        const { code, result } = await API.get('/v1/chatbot/service/status', option)
        if (code !== '200') return result

        commit('setChatbotStatus', result)

        return result
      } catch (error) {
        return error.response.data.result
      }
    }
  }
}

export default myOrderHistoryV2
